// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getCurrentAlbumSlug } from '@/lib/utils';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from "@/lib/constants"


// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Dynamic storage key per album for isolated sessions
    storageKey: `bk:${getCurrentAlbumSlug() || 'default'}`,
    detectSessionInUrl: true,
    flowType: 'pkce', // recomendado para SPA
  }
});